import { createOptionArray } from 'Shared/backend/widgets/ComponentOptions';
import { selectStyle } from 'Shared/forms/Inputs';
import { LayoutTypes } from 'Shared/model/Components';
import { useStore } from 'Shared/StoreProvider';
import { Show, For } from 'solid-js';
import { reconcile } from 'solid-js/store';
import { subdoc } from 'Common/ViewUtils';
import { initImage } from 'Shared/backend/widgets/CreationUtils';
import { initStyles } from 'Shared/backend/widgets/Styles';
import { initLink } from 'Shared/backend/widgets/LinkBlock';
import { initPopup } from 'Shared/backend/widgets/Popup';
import { initGrid } from 'Shared/backend/widgets/Grid';
import { initVertical } from 'Shared/backend/widgets/Vertical';
import { initOverlay } from 'Shared/backend/widgets/OverlayComponent';
import { initButtons } from 'Shared/backend/widgets/Buttons';
import { initSlides } from 'Shared/backend/widgets/Slides';
import { initVisualWithInfo } from 'Shared/backend/widgets/VisualWithInfo';
import { initEmbed } from 'Shared/backend/widgets/Embed';


export function LayoutSelector(P:{layout:LayoutTypes,required?:boolean,options:LayoutTypes[],expand?:()=>void})
{
	const sw = useStore();

//TODO add warning about losing content?

	const changeBlock = async e => {
		const newLayout = e.target.value;
		const old = JSON.parse(JSON.stringify(subdoc(sw.store,sw.location)));
		const content = initContent(old,newLayout);

		await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:content});
		sw.setStore(...sw.location,reconcile(content));

		P.expand?.();
	};

	return (
		<select class={selectStyle()} onChange={changeBlock} onClick={e => e.stopPropagation()}>
			<Show when={!P.required}>
				<option value='' selected={!P.layout}>None</option>
			</Show>

			<For each={Object.entries(createOptionArray(P.options))}>{ item => 
				<option value={item[0]} selected={item[0]==P.layout}>
					{item[1]}
				</option>
			}</For>
		</select>
	);
}

/*
	It would be nice to remove this glue code altogether. Bit challenging as I'd need to put
	onMounts into Vertical() etc, but I need to save the layout type before these functions are called.
	OPTIONS:
	1. Status quo: use initXXX() functions
		b. Add a vertical() call (for example) that returns {init:initVertical,component:Vertical}
			(CONS: probably overkill)
		c. Have initContent infer the initXXX name 
			(CONS: overkill, framework knowledge required)
	2. Update the DB twice - once for the 'type' field, once for the details.
	    The details can be added using 'onMount'.
		(CONS: prefer to have compulsary fields always present, inefficient)
*/
function initContent(old:any,layout:LayoutTypes)
{
	if (layout=='')
		return undefined;

	if (layout=='image')      return initImage();
	if (layout=='styles')     return initStyles(old);
	if (layout=='link')       return initLink(old);
	if (layout=='popup')      return initPopup(old);
	if (layout=='grid')       return initGrid(old);
	if (layout=='vertical')   return initVertical(old);
	if (layout=='overlay')    return initOverlay();
	if (layout=='buttons')    return initButtons();
	if (layout=='slides')     return initSlides(old);
	if (layout=='visualWithInfo') return initVisualWithInfo();
	if (layout=='embed')      return initEmbed();
//XXX posters missing here?

	return { layout };
}


